import { render, staticRenderFns } from "./OrganicHeader.vue?vue&type=template&id=1486ab83"
import script from "./OrganicHeader.vue?vue&type=script&lang=js"
export * from "./OrganicHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports